enum OwnershipErrorCodes {
  InvalidParam = "PBOWN1033E",
  AmountNotInteger = "PBOWN1034E",
  EmptyCurrency = "PBOWN1035E",
  InvalidReason = "PBOWN1036E",
  InvalidJSON = "PBOWN1037E",
  AdminUserUuidNotRetrievable = "PBOWN1038E",
  InvalidCurrency = "PBOWN1029E",
  SystemWalletNotRetrievable = "PBOWN1040E",
  UserWalletNotRetrievable = "PBOWN1041E",
  TransferCreationError = "PBOWN1042E",
  MissingAuthToken = "PBOWN1043E",
  AmountGreaterThanBalance = "PBOWN1063E",
  PBFlexiPointsAppInsufficientFunds = "PBFlexiPointsAppInsufficientFunds"
}

export default OwnershipErrorCodes
